import { render } from "./ShopCard.vue?vue&type=template&id=5a38296c"
import script from "./ShopCard.vue?vue&type=script&lang=js"
export * from "./ShopCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__